import { FC } from "react";
import { useTussendoortjes } from "../useTussendoortjes";
import { ITussendoortjesRow } from "../types";
import { TABLE_TYPES } from "components/inclusion/tableTypes";
import { TableFilters } from "./TableFIlters";
import { TableSearch } from "components/inclusion/components/TableSearch";
import { TableContent } from "components/inclusion/components/TableContent";

interface Props {
  rows: ITussendoortjesRow[];
}

const tableHeaders: { [key: string]: string } = {
  title: "Titel",
  themes: "Thema",
  difficulty: "Moeilijkheidsgraad",
};

export const TableWrapper: FC<Props> = ({ rows }) => {
  const {
    state: {
      sortColumn,
      sortDirection,
      filteredRows,
      themaOptions,
      favorites,
      difficultyOptions,
    },
    actions: {
      setSearch,
      setThema,
      handleSort,
      addToFavorites,
      removeFromFavorites,
      setDifficulty,
    },
  } = useTussendoortjes({ rows });

  return (
    <>
      <TableSearch setSearch={setSearch} />
      <TableFilters
        themaOptions={themaOptions}
        difficultyOptions={difficultyOptions}
        setThema={setThema}
        setDifficulty={setDifficulty}
      />
      <div style={{ width: "100%", overflowX: "auto", marginBottom: "48px" }}>
        <TableContent
          filteredRows={filteredRows}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          handleSort={handleSort}
          favorites={favorites}
          addToFavorites={addToFavorites}
          removeFromFavorites={removeFromFavorites}
          tableHeaders={tableHeaders}
          tableType={TABLE_TYPES.TUSSENDOORTJES}
        />
      </div>
    </>
  );
};
